import { useArchivedSearch } from './use-archived-search';
import { useArchivedBrowseSearch } from './use-archived-browse-search';
import type { SearchQuery } from './use-search-core';

const noopLoadMore = () => {};

// Archive page's single entry point. Term search keeps useArchivedSearch's existing
// bounded/relevance-ranked fetch (hasMore is always false — full-text results stay capped
// at 300). An empty term switches to useArchivedBrowseSearch's growing-limit pagination.
// Both hooks are called unconditionally (with `enabled` toggled) to keep hook-call order
// stable across renders.
export const useInfiniteArchivedSearch = (query: SearchQuery, enabled: boolean = true) => {
  const term = (query.term ?? '').trim();

  const termSearch = useArchivedSearch(query, enabled && !!term);
  const browseSearch = useArchivedBrowseSearch(query, enabled && !term);

  if (term) {
    return {
      data: termSearch.data,
      isLoading: termSearch.isLoading,
      hasMore: false,
      isLoadingMore: false,
      loadMore: noopLoadMore,
    };
  }

  return {
    data: browseSearch.data,
    isLoading: browseSearch.isLoading,
    hasMore: browseSearch.hasMore,
    isLoadingMore: browseSearch.isLoadingMore,
    loadMore: browseSearch.loadMore,
  };
};
